// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__-00cy","content":"LayoutSettings_content__3ZlVB"};